import {
  NavigationProp,
  ParamListBase,
  useNavigation,
} from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import {
  useIsClubSellingMemberships,
  useIsClubSellingStandardPackages,
} from "@/features/Club";
import { ClubStackNavigatorParamList } from "@/navigators/ClubNavigator";

import { navigationRef_atom } from "../atoms";
import {
  getNavigationForRoute,
  RouteLookupNavigation,
} from "../utils/getNavigationForRoute";
import { useGoToStore_session$key } from "./__generated__/useGoToStore_session.graphql";

export const useGoToStore = (
  sessionRef?: useGoToStore_session$key | null,
  navigationOverride?: RouteLookupNavigation,
  clubSlugOverride?: string
) => {
  const navigationRef = useAtomValue(navigationRef_atom);
  const contextNavigation = useNavigation<NavigationProp<ParamListBase>>();
  const navigation = navigationOverride ?? contextNavigation;

  const session = useFragment(useGoToStoreFragmentString, sessionRef);
  const club = session?.currentClientProfile?.member?.club;

  const isClubSellingMemberships = useIsClubSellingMemberships(club);
  const isClubSellingPackages = useIsClubSellingStandardPackages(club);
  const clubSlug = clubSlugOverride;
  const getClubNavigation = () =>
    navigationOverride?.getParent?.<
      NavigationProp<ClubStackNavigatorParamList>
    >() ??
    getNavigationForRoute<ClubStackNavigatorParamList>(navigation, "Store");

  const navigateToStoreRoute = (
    screen: "Memberships" | "Packages" | "StoreHome"
  ) => {
    if (!clubSlug || !navigationRef?.isReady()) {
      return false;
    }

    navigationRef.navigate("Club", {
      clubSlug,
      screen: "Store",
      params: { screen },
    });

    return true;
  };

  if (isClubSellingMemberships && !isClubSellingPackages) {
    return () => {
      if (!navigateToStoreRoute("Memberships")) {
        getClubNavigation().navigate("Store", { screen: "Memberships" });
      }
    };
  }

  if (isClubSellingPackages && !isClubSellingMemberships) {
    return () => {
      if (!navigateToStoreRoute("Packages")) {
        getClubNavigation().navigate("Store", { screen: "Packages" });
      }
    };
  }
  return () => {
    if (!navigateToStoreRoute("StoreHome")) {
      getClubNavigation().navigate("Store", { screen: "StoreHome" });
    }
  };
};

const useGoToStoreFragmentString = graphql`
  fragment useGoToStore_session on Session {
    currentClientProfile {
      member {
        ... on Customer {
          club {
            ...useIsClubSellingStandardPackages_club
            ...useIsClubSellingMemberships_club
          }
        }
      }
    }
  }
`;
